import PropTypes from 'prop-types'
import React, { Component } from "react"

import { connect } from "react-redux"
import { Link } from "react-router-dom"

import logo from "../../assets/images/VeeperLogo.svg"

//i18n
import { withTranslation } from "react-i18next"

// Redux Store
import { toggleRightSidebar } from "../../store/actions"

class Header extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isSearch: false,
      username: "Admin",
    }
    this.toggleMenu = this.toggleMenu.bind(this)
    this.toggleRightbar = this.toggleRightbar.bind(this)
    this.toggleFullscreen = this.toggleFullscreen.bind(this)
  }

  componentDidMount() {
    if (localStorage.getItem("authUser")) {
      try {
        const obj = JSON.parse(localStorage.getItem("authUser"))
        this.setState({ username: obj.displayName || obj.username || "Admin" })
      } catch (e) {
        // ignore parse errors
      }
    }
  }

  toggleMenu() {
    this.props.toggleMenuCallback()
  }

  toggleRightbar() {
    this.props.toggleRightSidebar()
  }

  toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen()
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen()
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        )
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      }
    }
  }

  getInitials = (name) => {
    return name
      .split(" ")
      .map(n => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2)
  }

  render() {
    const { t } = this.props
    const { username } = this.state

    return (
      <React.Fragment>
        <header id="page-topbar">
          <div className="navbar-header">
            {/* Left section */}
            <div className="d-flex align-items-center">
              <div className="navbar-brand-box">
                <Link to="/" className="logo logo-dark">
                  <span className="logo-sm">
                    <div className="brand-icon-box">
                      <img src={logo} alt="V" height="18" style={{ filter: 'brightness(0) invert(1)' }} />
                    </div>
                  </span>
                  <span className="logo-lg">
                    <div className="brand-icon-box">
                      <img src={logo} alt="Veeper" height="18" style={{ filter: 'brightness(0) invert(1)' }} />
                    </div>
                    <div className="brand-text-box">
                      <span className="brand-name">Veeper</span>
                      <span className="brand-subtitle">Admin Panel</span>
                    </div>
                  </span>
                </Link>

                <Link to="/" className="logo logo-light">
                  <span className="logo-sm">
                    <div className="brand-icon-box">
                      <img src={logo} alt="V" height="18" style={{ filter: 'brightness(0) invert(1)' }} />
                    </div>
                  </span>
                  <span className="logo-lg">
                    <div className="brand-icon-box">
                      <img src={logo} alt="Veeper" height="18" style={{ filter: 'brightness(0) invert(1)' }} />
                    </div>
                    <div className="brand-text-box">
                      <span className="brand-name">Veeper</span>
                      <span className="brand-subtitle">Admin Panel</span>
                    </div>
                  </span>
                </Link>
              </div>

              <button
                type="button"
                onClick={this.toggleMenu}
                className="btn btn-sm px-3 font-size-16 header-item header-toggle-btn waves-effect"
                id="vertical-menu-btn"
              >
                <i className="fa fa-fw fa-bars" />
              </button>

              <form className="app-search d-none d-lg-block">
                <div className="position-relative">
                  <input
                    type="text"
                    className="form-control"
                    placeholder={t("Search") + "..."}
                  />
                  <span className="bx bx-search-alt" />
                </div>
              </form>
            </div>

            {/* Right section */}
            <div className="d-flex align-items-center header-right-group">
              {/* Mobile search */}
              <div className="dropdown d-inline-block d-lg-none ms-2">
                <button
                  onClick={() => {
                    this.setState({ isSearch: !this.state.isSearch })
                  }}
                  type="button"
                  className="btn header-item header-action-btn waves-effect"
                  id="page-header-search-dropdown"
                >
                  <i className="mdi mdi-magnify" />
                </button>
                <div
                  className={
                    this.state.isSearch
                      ? "dropdown-menu dropdown-menu-lg dropdown-menu-right p-0 show"
                      : "dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
                  }
                  aria-labelledby="page-header-search-dropdown"
                >
                  <form className="p-3">
                    <div className="form-group m-0">
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search ..."
                          aria-label="Search"
                        />
                        <div className="input-group-append">
                          <button className="btn btn-primary" type="submit">
                            <i className="mdi mdi-magnify" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              {/* Fullscreen */}
              <div className="dropdown d-none d-lg-inline-block">
                <button
                  type="button"
                  onClick={this.toggleFullscreen}
                  className="btn header-item header-action-btn waves-effect"
                  data-toggle="fullscreen"
                  title="Fullscreen"
                >
                  <i className="bx bx-fullscreen" />
                </button>
              </div>

              {/* Divider */}
              <div className="header-divider d-none d-lg-block" />

              {/* Profile section */}
              <div className="header-profile-section">
                <div className="header-avatar">
                  {this.getInitials(username)}
                </div>
                <div className="header-profile-info d-none d-xl-block">
                  <span className="header-profile-name">{username}</span>
                  <span className="header-profile-role">Administrator</span>
                </div>
              </div>

              {/* Logout */}
              <Link to="/logout" className="header-action-btn header-logout-btn" title="Logout">
                <i className="bx bx-power-off" />
              </Link>
            </div>
          </div>
        </header>
      </React.Fragment>
    )
  }
}

const mapStatetoProps = state => {
  const { layoutType } = state.Layout
  return { layoutType }
}

export default connect(mapStatetoProps, { toggleRightSidebar })(
  withTranslation()(Header)
)

Header.propTypes = {
  t: PropTypes.any,
  toggleMenuCallback: PropTypes.any,
  toggleRightSidebar: PropTypes.func
}
